<template>
  <select>
    <slot/>
  </select>
</template>

<script>
import $ from 'jquery'
import { isArray } from 'bootstrap-vue/esm/utils/inspect'
import { keys } from 'bootstrap-vue/esm/utils/object'
import utilitiesMixin from '../../mixins/utilitiesMixin'

function isObject (obj) {
  return obj && ({}).toString.call(obj) === '[object Object]'
}

export default {
  name: 'Select2Host',
  mixins: [utilitiesMixin],
  props: {
    value: {},
    placeholder: String,
    callback: String,
    maximumSelectionLength: Number,
    tags: Boolean,
    options: {
      type: [Array, Object],
      default () {
        return []
      }
    },
    valueField: {
      type: String,
      default: 'value'
    },
    textField: {
      type: String,
      default: 'text'
    },
    disabledField: {
      type: String,
      default: 'disabled'
    }
  },
  data () {
    return { localValue: this.value }
  },
  watch: {
    value (value) {
      $(this.$el)
        .val(value)
        .trigger('change.select2')
    },
    options () {
      $(this.$el)
        .empty()
        .select2({
          data: this.formOptions,
          placeholder: this.placeholder,
          maximumSelectionLength: this.maximumSelectionLength,
          tags: this.tags
        })
        .val(this.value)
        .trigger('change.select2')
    }
  },
  computed: {
    formOptions () {
      const options = this.options

      const valueField = this.valueField
      const textField = this.textField
      const disabledField = this.disabledField

      if (isArray(options)) {
        // Normalize flat-ish arrays to Array of Objects
        return options.map(option => {
          if (isObject(option)) {
            return {
              id: option[valueField],
              text: String(option[textField]),
              disabled: option[disabledField] || false
            }
          }
          return {
            id: option,
            text: String(option),
            disabled: false
          }
        })
      } else {
        return keys(options).map(key => {
          const option = options[key] || {}
          if (isObject(option)) {
            const value = option[valueField]
            const text = option[textField]
            return {
              id: typeof value === 'undefined' ? key : value,
              text: typeof text === 'undefined' ? key : String(text),
              disabled: option[disabledField] || false
            }
          }
          return {
            id: key,
            text: String(option),
            disabled: false
          }
        })
      }
    }
  },
  methods: {
    createSelect () {
      const vm = this
      // CMM: Construccion de coponente con callback, usado para vistas de administrador con múltiples cursos
      if (vm.callback) {
        $(this.$el)
          .select2({
            ajax: {
              url: vm.callback,
              data: function (params) {
                let calculatedOffset = vm.defaultPagination() * (params.page ? params.page - 1 : 0)
                let query = {
                  fullName: params.term,
                  unirType: 'P',
                  limit: vm.defaultPagination(),
                  offset: calculatedOffset
                }
                return query
              },
              dataType: 'json',
              headers: {
                'Authorization': 'Bearer ' + this.$cookies.get('LTI_JWT')
              },
              processResults: function (data, params) {
                // CMM: Se construye la lista de valores a mostrar
                let results = []
                params.page = params.page || 1
                data.results.forEach(function (user, index) {
                  results.push({'id': user.unirId, 'text': user.fullName + ' [' + user.unirId + ']'})
                })
                return {
                  results: results,
                  pagination: {
                    more: (params.page * vm.defaultPagination()) < data.size
                  }
                }
              }
            },
            placeholder: this.placeholder,
            maximumSelectionLength: this.maximumSelectionLength,
            minimumInputLength: 5,
            allowClear: true,
            tags: this.tags,
            selectionCssClass: ':all:'
          })
          .val(this.value)
          .trigger('change.select2')
          .on('change', function (evt) {
            vm.localValue = this.value
            vm.$emit('input', vm.localValue)
          })
      } else {
        $(this.$el)
          .select2({
            data: this.formOptions,
            placeholder: this.placeholder,
            maximumSelectionLength: this.maximumSelectionLength,
            tags: this.tags,
            selectionCssClass: ':all:'
          })
          .val(this.value)
          .trigger('change.select2')
          .on('change', function (evt) {
            vm.localValue = this.value
            vm.$emit('input', vm.localValue)
          })
      }
    }
  },
  mounted () {
    this.createSelect()
  },
  destroyed () {
    $(this.$el).off().select2('destroy')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Select2/Select2Host.vue